module.exports = __webpack_public_path__ + "media/check-towers.399c2e45.mp4";